import React, { lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import MethodsCarousel from '../../../components/payments/methodsCarousel'

const Method = lazy(() =>
  import('../../../components/payments/withdraw/method')
)

const PENDING_STATUS = 'PENDING'

export const RegularWithdrawFlow = ({
  currentMethod,
  methods,
  status,
  onClose,
  isPage,
  initialAmount,
  prevalidateWithdrawalResponse,
}) => {
  return (
    <>
      {methods && methods.length > 0 && status !== PENDING_STATUS && (
        <MethodsCarousel methods={methods} numberOfSlides={isPage ? 7 : 5} />
      )}

      {currentMethod && status !== PENDING_STATUS && (
        <Suspense fallback={<div />}>
          <Method
            withdrawClose={onClose}
            isPage={isPage}
            initialAmount={initialAmount}
            prevalidateWithdrawalResponse={prevalidateWithdrawalResponse}
          />
        </Suspense>
      )}
    </>
  )
}

RegularWithdrawFlow.propTypes = {
  currentMethod: PropTypes.object,
  methods: PropTypes.array,
  status: PropTypes.string,
  onClose: PropTypes.func,
  isPage: PropTypes.bool,
  initialAmount: PropTypes.number,
  prevalidateWithdrawalResponse: PropTypes.object,
}
